import { API_URLS, API_METHOD } from '../../config/apiUrl';
import request from '../../helpers/requests';

export async function sendOTP(payload, params) {
    return await request(API_METHOD.POST, `${API_URLS.baseurl}${API_URLS.tablet.sendOTP}`, params, payload, null)
}

export async function verifyOTP(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurl}${API_URLS.tablet.verifyOTP}`, null, payload, null)
}

export async function submitSiteVisitForm(payload, params) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.submitSiteVisitForm}`, params, payload, null)
}

export async function verifySvCode(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.verifySvCode}`, null, payload, null)
}

export async function findCustomerWithEmailOrDocId(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.findCustomerWithEmailOrDocId}`, null, payload, null)
}

export async function getRevisitDetailsByOpportunityUuid(uuid) {
    return await request(API_METHOD.GET, `${API_URLS.baseurlV2}${API_URLS.tablet.getRevisitDetailsByOpportunityUuid}/${uuid}`, null, null, null)
}

export async function fetchBrokerCode(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurl}${API_URLS.tablet.fetchBrokerCode}`, null, payload, null)
}

export async function checkBrokerInCompany(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurl}${API_URLS.tablet.checkBrokerInCompany}`, null, payload, null)
}

export async function getBrokerCompanies(searchText) {
    return await request(API_METHOD.GET, `${API_URLS.baseurl}${API_URLS.tablet.getBrokerCompanies}`, { searchText }, null, null)
}

export async function searchCPCompaniesAndContacts(searchText) {
    return await request(API_METHOD.GET, `${API_URLS.baseurlV2 || API_URLS.baseurl}/public/searchCPCompaniesAndContacts`, { searchText }, null, null)
}
export async function requestCompanySignup(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurl}${API_URLS.tablet.requestCompanySignup}`, null, payload, null)
}

export async function completeProjectVisit(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.completeProjectVisit}`, null, payload, null)
}

export async function getReVisitCustomerDetails(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.getReVisitCustomerDetails}`, null, payload, null)
}

export async function getReVisitCustomerDetailsV2(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.getReVisitCustomerDetailsV2}`, null, payload, null)
}

export async function getSvFormConfig(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.getSvFormConfig}`, null, payload, null)
}

export async function getRunningSiteVisitsCount(payload = {}) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.getRunningSiteVisitsCount}`, null, payload, null)
}

export async function getRunningSiteVisits(payload = {}) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}${API_URLS.tablet.getRunningSiteVisits}`, null, payload, null)
}

export async function setClientOutTime(uuid, payload) {
    return await request(API_METHOD.PUT, `${API_URLS.baseurlV2}${API_URLS.tablet.setClientOutTime}/${uuid}`, null, payload, null)
}

export async function searchCpFirms(query, projectId = null) {
    const params = { query };
    if (projectId) {
        params.project_id = projectId;
    }
    return await request(API_METHOD.GET, `${API_URLS.baseurlV2}/companies/searchCpFirms`, params, null, null)
}

export async function checkExecMobileByFirmUUID(firmUuid, mobile) {
    return await request(API_METHOD.GET, `${API_URLS.baseurlV2}/companies/checkExecMobileByFirmUUID/${firmUuid}`, { mobile }, null, null)
}

export async function getMasterOtpReasons() {
    return await request(API_METHOD.GET, `${API_URLS.baseurlV2}${API_URLS.tablet.getMasterOtpReasons}`, null, null, null)
}

export async function getSourcingManagerByProjectIds(payload) {
    return await request(API_METHOD.POST, `${API_URLS.baseurlV2}/public/getSourcingManagerByProjectIds`, null, payload, { 'Content-Type': 'application/json' })
}